import Tag from '../reusable/Tag';

interface FocusGroupReportStatusProps {
  status: string | null;
  size?: 'small' | 'medium';
  className?: string;
}

export const getFocusGroupReportStatusDisplay = (
  status: string | null
): { text: string; type: 'pending' | 'completed' | 'progress' | 'error' } => {
  switch (status) {
    case 'NOT_STARTED':
      return { text: 'Not started', type: 'pending' };
    case 'AI_FAILED':
      return { text: 'In progress', type: 'progress' };
    case 'GENERATION_IN_PROGRESS':
    case 'AI_GENERATED':
      return { text: 'In progress', type: 'progress' };
    case 'FINALIZED':
      return { text: 'Approved', type: 'completed' };
    default:
      return { text: status || 'Not started', type: 'pending' };
  }
};

const FocusGroupReportStatus = ({ status, size = 'small', className }: FocusGroupReportStatusProps) => {
  const { text, type } = getFocusGroupReportStatusDisplay(status);
  return <Tag type={type} text={text} size={size} className={className} />;
};

export default FocusGroupReportStatus;
